import React from 'react';
import { useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { MessageCircle } from 'lucide-react';
import { galleryWhatsAppLink } from '../lib/whatsapp';

/**
 * Subtle floating WhatsApp button — bottom-left of the viewport (chatbot
 * already lives bottom-right). Discreet, gallery-grade styling. Only
 * renders on public pages (hidden on /admin*) and only when the env var
 * is set.
 *
 * The recipient phone number is NEVER rendered as text — it is encoded
 * solely into the wa.me href.
 */
const FloatingWhatsApp = () => {
  const { pathname } = useLocation();
  const href = galleryWhatsAppLink('Hello Zebra One Gallery, I have an enquiry.');
  if (!href) return null;
  if (pathname.startsWith('/admin')) return null;

  return (
    <motion.a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp-btn"
      aria-label="Message us on WhatsApp"
      title="WhatsApp us"
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 1.2, duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.97 }}
      className="
        fixed bottom-6 left-6 z-[60]
        w-12 h-12 sm:w-14 sm:h-14 rounded-full
        bg-[#25D366] text-white
        flex items-center justify-center
        shadow-lg shadow-black/20 hover:shadow-xl
        ring-2 ring-white/40
        transition-shadow
      "
    >
      <MessageCircle className="w-6 h-6 sm:w-7 sm:h-7" strokeWidth={1.8} />
    </motion.a>
  );
};

export default FloatingWhatsApp;
